import { PaymentDocuments } from "./PaymentDocuments"

export class PaymentDetails {
    customerId: string;
    primaryCustomerId: number;
    ebpCustomerId: number;
    userId: number;
    paymentAccountId: string;
    paymentDate: string;
    accountNumber: string;
    paymentNote: string;
    optpayone: number;
    optpaytwo: number;
    documents?: PaymentDocuments[] = [];
    createUser: string; 
    docPaySplitCreateUser: string;
    MerchantDescriptor: string;
    MerchantDescriptorContact: string;
    usesTemplateConvenienceFees: string;
    originSystem: string;
    convenienceFee: number;
    createDocPaySplits: boolean;
    zeroDollarPayment: string;
    IsFullAmountPaidByCreditMemo: string;
    serviceFeeAmount: string;
    waiveEditReason: string;
    skipConvenienceFeeCalculation: string;
    clientGuid: string;
}